import { reactive, ref } from "vue";
import { list } from "@/api/maintenance/geomagneticApi";
import useMessage from "@/hooks/useMessage";
import { listAll } from "../../api/parking/parkingLotApi";
const useGeomagnetic = () => {
  const { showErr } = useMessage();
  const loading = ref(false);
  const dataList = reactive({ list: [] });
  const total = ref(0);
  const parkingLotList = reactive([]);
  const geomagneticVo = reactive({
    name: "",
    sn: "",
    parkingLotId: null,
    parkingPlaceId: null,
  });

  const columns = [
    {
      title: "序号",
      align: "center",
      width: "80px",
      customRender: ({ index }) => {
        return index + 1;
      },
    },
    {
      title: "设备名称",
      align: "center",
      dataIndex: "name",
    },
    {
      title: "设备编号",
      align: "center",
      dataIndex: "sn",
    },
    {
      title: "所属车场名称",
      align: "center",
      dataIndex: "parkingLotName",
    },
    {
      title: "所属车位编号",
      align: "center",
      dataIndex: "parkingPlaceCode",
    },
    {
      title: "最后上报时间",
      align: "center",
      dataIndex: "lastReportTime",
    },
    {
      title: "添加时间",
      align: "center",
      dataIndex: "createTime",
    },
    {
      title: "操作",
      align: "center",
      width: "240px",
      slots: { customRender: "operation" },
    },
  ];
  const loadData = async (page, pageSize) => {
    loading.value = true;
    let p = {
      sn: params.sn,
      parkingLotId: params.parkingLotId,
      parkingPlaceId: params.parkingPlaceId,
      createTimeArr: params.createTimeArr? params.createTimeArr.toString(): [],
    }
    try {
      let res = await list(p, page, pageSize);
      dataList.list = res.data;
      total.value = res.total;
      loading.value = false;
    } catch (e) {
      loading.value = false;
      await showErr(e);
    }
  };

  const getParkingLotList = async () => {
    try {
      let { data } = await listAll();
      parkingLotList.push(...data);
    } catch (e) {
      showErr(e);
    }
  };

  const params = reactive({
    sn: "",
    parkingLotId: null,
    parkingPlaceId: null,
    createTimeArr: [],
  });
  return {
    loading,
    params,
    dataList,
    total,
    columns,
    loadData,
    getParkingLotList,
    geomagneticVo,
    parkingLotList,
  };
};

export default useGeomagnetic;
